// src/data/warRoomOverview.js - section 540: what the War Room shows on opening (pure). See components\WarRoomOverview.js.
import { deadlineReport, today } from './reports';
import { claimLabel, isOverdue, sortActions } from './warRoom';

export const GC_RUNGS = ['gc_review', 'valuation', 'negotiation', 'settlement'];
const RUNG_LABEL = { gc_review: 'GC Review', valuation: 'Valuation', negotiation: 'Negotiation', settlement: 'Settlement' };

// Pure: what the room shows, from the claims, sessions and action items it is handed.
export function roomOverview(claims, sessions, actions, t) {
  const day = t || today();
  const filed = (claims || []).filter(c => c && c.status && c.status !== 'draft');
  const atDesk = filed.filter(c => GC_RUNGS.includes(c.status));
  const dl = deadlineReport(filed, [], { today: day, horizonDays: 14 });
  const soonIds = new Set(dl.rows.map(r => r.ref).filter(Boolean));
  const openActs = (actions || []).filter(a => a && a.status !== 'done');
  const closed = (sessions || []).filter(s => s && s.state === 'closed').sort((a, b) => String(b.closedAt || '').localeCompare(String(a.closedAt || '')));
  const openSess = (sessions || []).filter(s => s && s.state === 'convened');
  const onTable = new Set(openSess.flatMap(s => (s.agendaItems || []).map(i => i.claimId)).filter(Boolean));
  const suggested = filed.filter(c => (GC_RUNGS.includes(c.status) || soonIds.has(c.docId || c.id)) && !onTable.has(String(c.docId || c.id)))
    .map(c => ({ claim: c, why: [GC_RUNGS.includes(c.status) ? 'at your desk (' + RUNG_LABEL[c.status] + ')' : null, soonIds.has(c.docId || c.id) ? 'deadline within 14 days' : null].filter(Boolean).join('; ') }))
    .slice(0, 12);
  return {
    atDesk: atDesk.length, deadlines: dl.rows, overdue: dl.overdue, openActions: sortActions(openActs),
    overdueActions: openActs.filter(a => isOverdue(a, day)).length, lastMeeting: closed[0] || null, openMeetings: openSess.length, suggested,
  };
}

